import { Link } from "react-router-dom";
import { Box, Divider, Grid, Typography, Link as MUILink } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";

import { featuresRoutes, ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import MenuContacts from "../ContactsMenu";
import MenuFeatures from "../IndustriesMenu/MenuFeatures";
import SubMenuHeading from "../SubMenuHeading";

interface IProps {
  closeDropDown: () => void;
}

const technologyLinks = [
  { path: ROUTES.whyTrackmate, title: "Why Trackmate" },
  { path: ROUTES.features, title: "All Features" },
  { path: ROUTES.getTrackmate, title: "Get Trackmate" },
];

const TechnologyMenu: React.FC<IProps> = ({ closeDropDown }) => {
  const isMobile = useResponsive("down", "lg");

  return (
    <>
      {!isMobile && <SubMenuHeading title="Technology" />}

      <Grid
        container
        columnSpacing={2}
        rowSpacing={{ xs: 2, xl: 3.5 }}
        mb={{ xs: 4, md: 6, xl: 8 }}
        pl={isMobile ? 3 : 0}
      >
        {technologyLinks.map(({ path, title }) => (
          <Grid item xs={12} lg={3} key={path} onClick={closeDropDown}>
            <MUILink
              component={Link}
              to={path}
              style={{ textDecoration: "none" }}
            >
              <Typography
                variant="subtitle1"
                component="p"
                fontWeight={700}
                color="inherit"
                textTransform="capitalize"
              >
                {title}
              </Typography>
            </MUILink>
          </Grid>
        ))}
      </Grid>

      <SubMenuHeading title="Features" />

      {isMobile ? (
        <Box
          component={Swiper}
          sx={{ maxWidth: "100%", mb: { xs: 3, lg: 0 } }}
          spaceBetween={24}
          loop={true}
          centeredSlides={true}
          slidesPerView="auto"
          className="feature-swiper"
        >
          {featuresRoutes.map((featureData, index) => (
            <SwiperSlide key={index}>
              <MenuFeatures {...featureData} onClick={closeDropDown} />
            </SwiperSlide>
          ))}
        </Box>
      ) : (
        <Grid container spacing={{ xs: 3, xl: 4 }} mb={{ xs: 4, xl: 7.5 }}>
          {featuresRoutes.map((featureData) => (
            <Grid item xs={4} lg={3} key={featureData.path}>
              <MenuFeatures {...featureData} onClick={closeDropDown} />
            </Grid>
          ))}
        </Grid>
      )}

      {!isMobile && (
        <>
          <Divider />
          <MenuContacts closeDropDown={closeDropDown} />
        </>
      )}
    </>
  );
};

export default TechnologyMenu;
